var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1993 47.1981C41.2327 47.1981 51.7983 36.6324 51.7983 23.5991C51.7983 10.5657 41.2327 0 28.1993 0C15.1659 0 4.60022 10.5657 4.60022 23.5991C4.60022 36.6324 15.1659 47.1981 28.1993 47.1981Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1382 33.0137L18.3239 32.7541L27.1037 16.0948L27.1222 15.9189L23.2514 8.64763C22.9267 8.03835 22.0144 8.19257 21.9079 8.87462L18.1382 33.0137Z",
    fill: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2479 32.8149L18.388 32.5413L27.0744 16.0568L23.2156 8.75732C22.8952 8.15454 22.0795 8.30877 21.9742 8.98322L18.2479 32.8149Z",
    fill: "#FFA412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2479 32.8149L18.388 32.5413L27.0744 16.0568L23.2156 8.75732C22.8952 8.15454 22.0795 8.30877 21.9742 8.98322L18.2479 32.8149Z",
    fill: "#FDA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9427 21.4166L32.8241 18.4658L29.9416 12.9626C29.6679 12.4413 28.9044 12.4402 28.6329 12.9626L27.0939 15.9005V16.1502L29.9427 21.4166Z",
    fill: "#F1BA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8917 21.2939L32.6927 18.4245L29.8917 13.0897C29.6256 12.5825 28.9794 12.5304 28.7165 13.0376L27.1678 16.0199L27.1211 16.172L29.8917 21.2939Z",
    fill: "#FFA20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8917 21.2939L32.6927 18.4245L29.8917 13.0897C29.6256 12.5825 28.9794 12.5304 28.7165 13.0376L27.1678 16.0199L27.1211 16.172L29.8917 21.2939Z",
    fill: "#FDA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1016 15.8842L18.1382 33.0137L18.2218 32.929L18.527 32.8052L29.7624 21.6121L29.9047 21.2244L27.1016 15.8842Z",
    fill: "#F3800C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3033 38.658L40.4711 32.9876L37.568 15.1054C37.4768 14.5461 36.7904 14.3245 36.3907 14.7264L18.1382 33.0137L28.2474 38.658C28.886 39.0143 29.6636 39.0143 30.3033 38.658Z",
    fill: "#FADD68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3799 32.9398L37.4985 15.1934C37.4084 14.6384 36.8371 14.4082 36.4396 14.8067L18.2511 32.9789L28.2495 38.5668C28.8838 38.9209 29.656 38.9209 30.2903 38.5668L40.3799 32.9398Z",
    fill: "#F9C73F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3033 38.4908C29.6647 38.847 28.886 38.847 28.2474 38.4908L18.2196 32.9279L18.1382 33.0137L28.2474 38.6581C28.886 39.0143 29.6647 39.0143 30.3033 38.6581L40.4711 32.9877L40.4461 32.8345L30.3033 38.4908Z",
    fill: "#EBA837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_96",
    x: 0.60022,
    y: 0,
    width: 55.1981,
    height: 55.1981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_96"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_96",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriebase);
export default __webpack_public_path__ + "static/media/friebase.3168ecd2049bc48c7ce7fe5226f6c5fc.svg";
export { ForwardRef as ReactComponent };